/**
 * 카테고리 랜딩 기본 설문: 공통 3문항(c1,c2,c3) + 카테고리별 2문항(cat1,cat2).
 * 순서: c1 → c2 → cat1 → cat2 → c3 (마지막 c3만 주관식 textarea)
 */

const COMMON_C1 = {
  id: 'c1',
  type: 'select',
  label: '이번 상담에서 가장 먼저 확인하고 싶은 것은 무엇인가요?',
  required: false,
  options: ['부족한 보장 확인', '중복 보장 정리', '보험료 부담 점검', '현재 가입 내용 이해', '아직 잘 모르겠음'],
}

const COMMON_C2 = {
  id: 'c2',
  type: 'select',
  label: '현재 관련 자료를 가지고 계신가요?',
  required: false,
  options: ['보험 증권/가입내역이 있다', '일부만 있다', '없다', '잘 모르겠다'],
}

const COMMON_C3 = {
  id: 'c3',
  type: 'textarea',
  label: '추가로 미리 전달하고 싶은 내용이 있나요?',
  required: false,
  placeholder: '예) 최근 가입한 보험, 걱정되는 질환, 가족 상황 등',
}

const CATEGORY_MIDDLE = {
  HIDDEN_INSURANCE_MONEY: [
    {
      id: 'cat1',
      type: 'text',
      label: '기억나는 보험사나 상품이 있나요?',
      required: false,
      placeholder: '예) 삼성생명, 한화생명, 실손보험, 암보험',
    },
    {
      id: 'cat2',
      type: 'select',
      label: '보험금 청구 여부를 기억하시나요?',
      required: false,
      options: ['청구한 적이 있다', '청구한 적이 없는 것 같다', '잘 모르겠다', '가족이 대신 진행해서 모르겠다'],
    },
  ],
  COVERAGE_ANALYSIS: [
    {
      id: 'cat1',
      type: 'select',
      label: '현재 보험 가입 상태는 어떤가요?',
      required: false,
      options: ['생명보험 위주', '손해보험 위주', '여러 개 가입', '몇 개 있는 것 같지만 잘 모름', '거의 없다'],
    },
    {
      id: 'cat2',
      type: 'select',
      label: '가장 걱정되는 부분은 무엇인가요?',
      required: false,
      options: ['중복 보장', '부족한 보장', '보험료가 많은 것 같음', '어떤 보험인지 잘 모르겠음', '가족 보장까지 함께 보고 싶음'],
    },
  ],
  PRODUCT_AUTO: [
    {
      id: 'cat1',
      type: 'select',
      label: '이번 상담은 어떤 상황에 해당하나요?',
      required: false,
      options: ['첫 가입', '갱신 예정', '다른 상품과 비교 검토', '차량 변경 예정', '운전자 범위 변경 예정'],
    },
    {
      id: 'cat2',
      type: 'select',
      label: '가장 중요하게 보는 기준은 무엇인가요?',
      required: false,
      options: ['보험료', '대인/대물 보장', '자차 보장', '긴급출동 등 편의 서비스', '잘 모르겠어서 설명이 필요함'],
    },
  ],
  PRODUCT_COMPREHENSIVE: [
    {
      id: 'cat1',
      type: 'select',
      label: '종합보험 상담이 필요한 가장 큰 이유는 무엇인가요?',
      required: false,
      options: ['전체적으로 점검하고 싶음', '가족 상황이 바뀜', '부족한 보장이 걱정됨', '보험이 많은데 정리가 안 됨', '권유받았지만 잘 모르겠음'],
    },
    {
      id: 'cat2',
      type: 'select',
      label: '이번에 함께 보고 싶은 범위는 어디까지인가요?',
      required: false,
      options: ['본인만', '배우자 포함', '자녀 포함', '부모님 포함', '아직 정하지 못함'],
    },
  ],
  PRODUCT_PENSION: [
    {
      id: 'cat1',
      type: 'select',
      label: '연금보험을 생각하게 된 가장 큰 이유는 무엇인가요?',
      required: false,
      options: ['노후 생활비 준비', '은퇴 이후 안정감', '여유 자금 마련', '기존 상품 비교', '아직 구체적인 이유는 없고 관심만 있음'],
    },
    {
      id: 'cat2',
      type: 'select',
      label: '현재 연금 준비 상태는 어떤가요?',
      required: false,
      options: ['이미 준비 중이다', '조금만 준비되어 있다', '거의 시작하지 않았다', '다른 금융상품과 함께 비교 중이다', '잘 모르겠다'],
    },
  ],
  PRODUCT_WHOLE_LIFE: [
    {
      id: 'cat1',
      type: 'select',
      label: '종신보험 상담을 생각하게 된 가장 큰 이유는 무엇인가요?',
      required: false,
      options: ['가족 보호', '사망 보장 준비', '기존 상품 점검', '권유받았지만 잘 모르겠음', '아직 필요 여부를 판단 중'],
    },
    {
      id: 'cat2',
      type: 'select',
      label: '이번 상담에서 가장 궁금한 부분은 무엇인가요?',
      required: false,
      options: ['나에게 꼭 필요한지', '보장 규모를 어느 정도로 봐야 하는지', '보험료를 오래 유지할 수 있을지', '다른 보험과 차이가 무엇인지', '설명부터 듣고 싶음'],
    },
  ],
  PRODUCT_CARE: [
    {
      id: 'cat1',
      type: 'select',
      label: '간병보험은 누구를 위한 상담인가요?',
      required: false,
      options: ['본인', '부모님', '배우자', '가족 전체 검토', '아직 정하지 못함'],
    },
    {
      id: 'cat2',
      type: 'select',
      label: '가장 걱정되는 부분은 무엇인가요?',
      required: false,
      options: ['장기 간병 비용', '가족 돌봄 부담', '어떤 담보를 봐야 하는지 모름', '기존 보장으로 충분한지 궁금함', '지금 준비가 필요한지부터 알고 싶음'],
    },
  ],
  PRODUCT_FIRE: [
    {
      id: 'cat1',
      type: 'select',
      label: '보장을 검토하려는 대상은 무엇인가요?',
      required: false,
      options: ['주택', '상가', '오피스텔', '임대 건물', '기타'],
    },
    {
      id: 'cat2',
      type: 'select',
      label: '가장 먼저 확인하고 싶은 부분은 무엇인가요?',
      required: false,
      options: ['건물/재산 피해 보장', '화재 시 배상책임', '현재 보험이 충분한지', '건물 유형에 맞는 보장', '처음이라 기본 설명이 필요함'],
    },
  ],
  INSURANCE_REMODELING: [
    {
      id: 'cat1',
      type: 'select',
      label: '보험 리모델링을 생각하게 된 가장 큰 이유는 무엇인가요?',
      required: false,
      options: ['보험료가 부담됨', '오래된 보험이라 점검이 필요함', '가족/생활 상황이 달라짐', '중복 보장이 있는 것 같음', '부족한 보장이 걱정됨'],
    },
    {
      id: 'cat2',
      type: 'select',
      label: '이번 점검에서 가장 먼저 보고 싶은 것은 무엇인가요?',
      required: false,
      options: ['줄일 수 있는 보험료', '유지해야 할 보험', '보완이 필요한 보장', '전체 구조 정리', '어디서부터 봐야 할지 설명이 필요함'],
    },
  ],
  PERSONAL_INTRO: [
    {
      id: 'cat1',
      type: 'select',
      label: '어떤 상담에 관심이 있으신가요?',
      required: false,
      options: ['보장분석', '보험 리모델링', '자동차보험', '연금보험', '아직 정하지 못함'],
    },
    {
      id: 'cat2',
      type: 'select',
      label: '이번 상담에서 기대하는 것은 무엇인가요?',
      required: false,
      options: ['내 상황에 맞는 설명', '현재 보험 점검', '필요한 상품 방향 제안', '부담 없는 1:1 상담', '우선 간단한 안내만 받고 싶음'],
    },
  ],
}

export function buildDefaultSurveyCustomFields(category) {
  const key = String(category || '')
  const middle = CATEGORY_MIDDLE[key] || CATEGORY_MIDDLE.COVERAGE_ANALYSIS
  return [COMMON_C1, COMMON_C2, ...middle, COMMON_C3]
}
